<script>
export default {
  name: 'BaseCard',
  functional: true,
  props: {
    type: {
      type: String,
    },
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
    action: {
      type: String,
      default: 'right',
    },
    actionButton: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    alert: {
      type: Object,
      default: () => ({ show: false }),
    },
  },
  render(h, ctx) {
    const props = ctx.props;
    const slots = ctx.slots();

    let alert;
    if (props.alert && props.alert.show) {
      alert = (
        <el-alert
          type= { props.alert.type}
          show-icon
          hide-close
          border= { props.alert.border }
          description={ props.alert.description }
        />
      );
    }

    let header;
    if (props.title || props.icon || slots.header) {
      let icon;
      if (props.icon) {
        icon = (
          <el-icon
            name={ props.icon }
            color={ props.type ? `fixed-${props.type}` : 'brand-light' }
            left
          />
        );
      }
      header = slots.header
        ? (
          <div>
            { slots.header }
          </div>
        )
        : (
          <div
            class={ `el-card__header px-24 py-${props.narrow ? 8 : 16}` }>
            <span
              class="el-text--size-m el-text--height-m">
              { icon }
              { props.title }
            </span>
          </div>
        )
    }

    const contents = [];
    if (slots.default) {
      slots.default.forEach((slot) => {
        if (slot.tag) {
          contents.push(
            (<el-divider />),
            slot,
          );
        }
      });
    }

    let action;
    if (slots.action) {
      action = (
        <div
          class={ `el-card__action px-24 el-text--body-32 is-${props.action} is-${props.actionButton ? 'button-style' : ''}` }>
          {
            slots.action.reduce((accu, slot, index) => {
              if (slot.tag) {
                if (props.action === 'center' && index > 0) {
                  accu.push((<el-divider vertical={ 48 } />));
                }
                accu.push(slot);
              }
              return accu;
            }, [])
          }
        </div>
      );
    }
    return (
      <el-card
        border-color={ props.type ? `fixed-${props.type}` : 'brand-lighter' }
        class={ {
          [`el-card--${props.type}`]: !!props.type,
        } }>
        { header }
        { alert }
        { contents }
        { action ? (<el-divider />) : null }
        { action }
      </el-card>
    );
  },
};
</script>
